{
  "name": "ticket-frontend",
  "version": "v1.8.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc": "compodoc -p tsconfig.json -s --theme [material]"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/build-angular": "^17.3.17",
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.12",
    "@angular/material": "^17.3.10",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@types/leaflet": "^1.9.17",
    "chart.js": "^4.4.9",
    "compodoc": "^0.0.6",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.1",
    "leaflet": "^1.9.4",
    "mat-table-exporter": "^15.0.0",
    "ngx-skeleton-loader": "^8.1.0",
    "rxjs": "~7.8.0",
    "schematics-scss-migrate": "^2.3.17",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular/cli": "^17.3.8",
    "@angular/compiler-cli": "^17.3.0",
    "@compodoc/compodoc": "^1.1.25",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.19.20",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "^4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "typescript": "~5.4.2"
  }
}
